import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import React from 'react';
import NumberFormat from 'react-number-format';

const NumberCellRenderer: React.FC<ICellRendererParams> = (props) => {
  return (
    <>
      {typeof props.value === 'number' && (
        <NumberFormat value={props.value} displayType={'text'} thousandSeparator={true} />
      )}
    </>
  );
};

export default NumberCellRenderer;
